import { SettlementsService } from 'src/app/services/settlements.service';
import { Component, inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentsService } from 'src/app/services/payments.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { Tenant } from 'src/app/models/tenant.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { concatMap, map } from 'rxjs';
declare var OpenPay: any;

const STATUS_CODES: { [key: number]: string } = {
  1: 'Pending',
  2: 'Revision',
  3: 'Approved',
  4: 'Rejected'
};

@Component({
  selector: 'app-transaction-success',
  template: `
  <div class="d-flex flex-fill flex-column justify-content-center align-items-center" style="width: 340px; max-width: 340px; margin: 0 auto;" *ngIf="loading" >
    <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-info mt-2"></fa-icon>
    <p class="text-muted">Cargando...</p>   
  </div>
  <!-- bloque de pago exitoso -->
  <div class="d-flex" *ngIf="!loading && success">
    <div class="flex-fill flex-column justify-content-center align-items-center" style="width: 340px; max-width: 340px; margin: 0 auto;">
      <div class="card border rounded-4 bg-white shadow">
        <div class="card-body px-4 py-3">
          <div class="d-flex justify-content-center mb-4">
            <div class="flex-fill text-center">
              <div class="text-center mt-5">
                <fa-icon [icon]="icons.faCircleCheck" size="4x" class="text-zazz mb-4"></fa-icon>
                <h2 class="mb-0 mt-5">Tu pago ha sido recibido</h2>
                <p class="mb-0">Gracias por tu pago, este será procesado en las próximas 48 horas.</p>
              </div>
              <div class="text-center mt-4">
                <h5><i># {{transaction.transaction_id}}</i></h5>
                <p>Recibo: {{bill.id}}</p>
              </div>
              <button type="button"
                class="btn btn-zazz-dark w-100 mt-3" 
                *ngIf="authService.hasPermission('can_read_payments')"
                routerLink="/tenant/bills/{{tenant.id}}"
              >Terminar</button>
              <div class="text-center mt-2">
                <p class="text-muted text-sm mb-0">Recuerda que cuentas con 7 días para generar tu factura</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Bloque de pago no exitoso -->
  <div class="d-flex" *ngIf="!loading && !success">
      <div class="flex-fill flex-column justify-content-center align-items-center" style="width: 340px; max-width: 340px; margin: 0 auto;">
        <div class="card border rounded-4 bg-white shadow">
          <div class="card-body px-4 py-3">
            <div class="d-flex justify-content-center mb-4">
              <div class="flex-fill text-center">
                <div class="text-center mt-5">
                  <h2 class="card-title mb-4">Intento de pago fallido</h2>
                  <p class="mb-0">El pago no se realizó de manera exitosa.</p>
                </div>
                <div class="text-center mt-5">
                  <p class="text-danger mb-0">Por favor revisa con tu banco e intenta de nuevo más tarde.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class TransactionSuccessComponent implements OnInit {
  bill: any = {};
  transaction: any = {};
  loading: boolean = true;
  tenant: Tenant = {};
  storageService = inject(StorageService);
  success = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private settlementsService: SettlementsService,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.tenant = this.storageService.getItem(STORAGE_KEYS.USER) ?? {};
    const transactionId = activatedRoute.snapshot.queryParamMap.get('id');
    const billId = activatedRoute.snapshot.paramMap.get('id');
    if (billId) {
      this.settlementsService.getTransactionByBillId(billId)
        .subscribe({
          next: (res) => {
            const statusCode = typeof res.status_code ? Number(res.status_code) : res.status_code;
            if (STATUS_CODES[statusCode] === 'Approved') {
              this.success = true;
              if (transactionId) {
                this.settlementsService.updateTransaction(transactionId, { status_code: 3, error_code: '00', error_message: 'Approved' })
                  .pipe(
                    concatMap((transaction: any) => {
                      this.transaction = transaction;
                      return this.settlementsService.getBill(billId);
                    })
                  )
                  .subscribe({
                    next: (billData: any) => {
                      this.bill = billData;
                    },
                    error: () => {},
                    complete: () => {
                      this.loading = false;
                    }
                  });
              }
            } else {
              this.success = false;
            }
          },
          error: () => {},
          complete: () => {
            this.loading = false;
          }
        })
    }
  }

  ngOnInit(): void {}

  cardType(cardType: string) {
    let card: string = '';

    if (cardType === 'VI') {
      card = "assets/images/icon-visa-sm.png";
    } else if (cardType === 'MC') {
      card = "assets/images/icon-mastercard-sm.png";
    } else if (cardType === 'AMEX') {
      card = "assets/images/icon-amex-sm.png";
    }
    
    return card;
  }
}
